import { render } from "./SizeList.vue?vue&type=template&id=06ca136a&scoped=true&ts=true"
import script from "./SizeList.vue?vue&type=script&lang=ts"
export * from "./SizeList.vue?vue&type=script&lang=ts"

import "./SizeList.vue?vue&type=style&index=0&id=06ca136a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ca136a"]])

export default __exports__